import React from "react";
import useInView from "../hooks/useInView";
import CountUp from "./CountUp";
import { useRole } from "../context/RoleContext";

const COLORS = ["#FF8A5B", "#FFD2A6", "#FF8A5B", "#FFD2A6"];

const Metrics = () => {
  const { metrics } = useRole();
  const bigNumbers = metrics.items;
  const [ref, inView] = useInView();

  return (
    <section
      id="numbers"
      data-testid="numbers-section"
      className="relative border-t border-white/5 overflow-hidden"
      style={{ backgroundColor: "#09090A" }}
    >
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(700px 320px at 5% 0%, rgba(189, 195, 199,0.08), transparent 55%), radial-gradient(700px 320px at 95% 100%, rgba(236, 240, 241,0.08), transparent 55%)"
        }}
      />

      <div ref={ref} className="relative container-x py-16 md:py-24">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10 md:mb-12">
          <div>
            <div className="eyebrow mb-3">§ By the numbers</div>
            <h2 className="display text-[36px] md:text-[56px] leading-[0.98] text-[#FFF3E9]">
              Receipts &gt; <span className="serif-italic text-[#B8B8BC]">vibes.</span>
            </h2>
          </div>
          <p className="text-[14px] text-[#9A9AA0] max-w-xs md:text-right">
            {metrics.blurb}
          </p>
        </div>

        {/* 4-cell brutalist grid */}
        <div className="grid grid-cols-2 md:grid-cols-4">
          {bigNumbers.map((n, i) => {
            const accent = COLORS[i % COLORS.length];
            return (
              <div
                key={n.label}
                data-testid={`big-number-${i}`}
                className={`brutal-cell relative p-5 md:p-8 group cursor-default transition-all duration-700`}
                style={{
                  marginLeft: i > 0 ? "-1px" : 0,
                  opacity: inView ? 1 : 0,
                  transform: inView ? "translateY(0)" : "translateY(28px)",
                  transitionDelay: `${i * 110}ms`
                }}
              >
                {/* corner color tag */}
                <span
                  aria-hidden
                  className="absolute top-3 right-3 w-2.5 h-2.5 rounded-full"
                  style={{ backgroundColor: accent, boxShadow: `0 0 12px ${accent}` }}
                />

                <CountUp
                  value={n.stat}
                  className="display block text-[44px] md:text-[72px] lg:text-[88px] leading-[0.95] tracking-tighter group-hover:scale-105 transition-transform duration-300 origin-left"
                  style={{ color: accent }}
                />
                <div className="mt-3 text-[14px] md:text-[15px] text-[#EDEDED] font-medium">
                  {n.label}
                </div>
                <div className="mt-2 mono text-[10px] tracking-widest uppercase text-[#8B7B6E]">
                  {n.note}
                </div>

                {/* hover bottom underline */}
                <span
                  aria-hidden
                  className="absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-500"
                  style={{ backgroundColor: accent }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Metrics;
